<template>
    <v-modal-confirmed accept-button-text="Borrar"
                       close-button-text="Cancelar"
                       title="Borrar estado"
                       confirm-modal-accept-button-text="Sí"
                       confirm-modal-close-button-text="No"
                       confirm-modal-text="¿Estás seguro?"
                       confirm-modal-title="Confirmar..."
                       @closed="closeModal"
                       @accepted="deleteStatus">
        <span>¿Seguro que quieres eliminar este estado?</span>
        <div>Estado: <strong>{{ status.display_name }} ({{ status.date ? status.date : 'Sin fecha' }})</strong></div>
        <div>Observaciones: <span class="user-name">{{ status.extra_data }}</span></div>
    </v-modal-confirmed>
</template>

<script>
import VModalConfirmed from "../../general/VModalConfirmed";
import {deleteExpedientStatus} from "../../../helpers/requests/RequestsStatuses";

export default {
    name: "StatusesListDeleteModal",
    components: {VModalConfirmed},
    props: {
        status: {
            type: Object,
            required: true,
        },
        expedient: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async deleteStatus() {
            try {
                await deleteExpedientStatus(this.expedient, this.status);

                this.$store.dispatch('app/setToastMessage', 'Estado del expediente eliminado');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al eliminar el estado');
            }
        },
        closeModal() {
            this.$emit('closed');
            this.$emit('closed');
        }
    }
}
</script>
